import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { connect } from 'react-redux'
import smoothScroll from 'smoothscroll'
import ErrorMessage from 'components/error-message'
import { getStaticUrl } from 'utils/files'
import Header from './header'
import Features from './features'
import Brands from './brands'
import Form from './form'
import Sidebar from './sidebar'

import styles from './ticketing-page.css'
import '../../styles/fonts.css'

const market = {
  tradedeskEmail: 'events@timeout.com',
  tradedeskPhone: '+442033224741',
}

export class Ticketing extends Component {

  handleGetStarted() {
    smoothScroll(document.body.scrollHeight)
  }

  handleGetInTouch() {
    document.location = 'https://yplanapp.com/list-my-event'
  }

  render() {
    const { staticUrl } = this.props

    return (
      <div styleName="page">
        <div styleName="content">
          <div styleName="error">
            <ErrorMessage isFixed market={market} />
          </div>
          <Header staticUrl={staticUrl} onGetStarted={this.handleGetStarted} onGetInTouch={this.handleGetInTouch} />
          <Features staticUrl={staticUrl} />
          <Brands staticUrl={staticUrl} />
          <Form staticUrl={staticUrl} />
        </div>
        <Sidebar onGetStarted={this.handleGetStarted} onGetInTouch={this.handleGetInTouch} />
      </div>
    )
  }

}

Ticketing.propTypes = {
  staticUrl: PropTypes.string,
}

const mapStateToProps = state => ({ staticUrl: getStaticUrl(state.settings) })

export default connect(mapStateToProps)(CSSModules(Ticketing, styles))



/** WEBPACK FOOTER **
 ** ./src/containers/ticketing-page/ticketing-page.js
 **/